export function isTrialExpired(user) {
  if (!user) return false;
  if (user.plan === "paid") return false;
  if (!user.trial_ends_at) return false;

  const trialEnd = new Date(user.trial_ends_at);
  if (Number.isNaN(trialEnd.getTime())) return false;

  return new Date() >= trialEnd;
}
